<!--
    描述：详细分析首页
    时间：2020-06-3
    Created by 郑勇
-->
<template>
    <grid-layout :layout="testLayout" :col-num="60" :row-height="layoutHeight" :vertical-compact="true" :use-css-transforms="false" >
        <grid-item :static="testLayout[0].static" :x="testLayout[0].x" :y="testLayout[0].y" :w="testLayout[0].w" :h="testLayout[0].h" :i="testLayout[0].i">
            <vxe-grid ref="xTable"
                    border
                    resizable
                    highlight-current-row
                    highlight-hover-row
                    export-config
                    keep-source
                    row-id="id"
                    @cell-click="leftGridItemClick"
                    :show-header="showHeader"
                    :height="layoutHeight"
                    :row-style="rowStyle"
                    :header-cell-style="headerCellStyle"
                    :data="leftTreeGrid"
                    :columns="oneTableColumn"
                    :toolbar="oneTableToolbar"
                    :tree-config="{children: 'children', expandRowKeys: defaultExpandKeys}"> <!--expandAll: true-->
                <template v-slot:toolbar_one_buttons>
                    <el-row>
                        <el-col :span="23">
                            <div style="font-size: 16px;font-weight: bold;color: #0c1c21;">{{pannelClass == 'el-icon-d-arrow-right' ? '':'项目结构 （ 请选择单位工程 ）'}}</div>
                        </el-col>
                        <el-col :span="1" style="min-width: 10px">
                            <i :class="pannelClass" @click="controlPannel"></i>
                        </el-col>
                    </el-row>
                </template>
            </vxe-grid>
        </grid-item>
        <grid-item :static="testLayout[1].static" :x="testLayout[1].x" :y="testLayout[1].y" :w="testLayout[1].w" :h="testLayout[1].h" :i="testLayout[1].i">
            <vxe-grid
                    border
                    resizable
                    keep-source
                    highlight-current-row
                    highlight-hover-row
                    export-config
                    show-footer
                    ref="xGrid"
                    :height="layoutHeight"
                    id="toolbar_2"
                    header-align='center'
                    :header-cell-style="tableStyle"
                    :cell-style="cellStyle"
                    :data="grid_data"
                    :custom-config="tableCustom"
                    :columns="tableColumn"
                    :footer-method="footerMethod"
                    :toolbar="tableToolbar">
                <template v-slot:toolbar_buttons>
                    <grid-layout :layout="testLayout" :col-num="36" :row-height="52" :vertical-compact="true" :use-css-transforms="false" >
                        <grid-item :static="true" :x="0" :y="0" :w="30" :h="1" :i="0">
                            <div style="font-size: 16px;font-weight: bold;color: #0c1c21;height:52px;line-height:52px;">
                                <!-- 祁门路小学 | 地库 | 地库土建 -->
                                {{ rowNodeShowName }}
                            </div>
                        </grid-item>
                        <grid-item :static="true" :x="30" :y="0" :w="2" :h="1" :i="1" class="grid-item">
                            <el-button type="warning" icon="el-icon-upload" size="small" class="mr10">重置</el-button>
                        </grid-item>
                        <grid-item :static="true" :x="32" :y="0" :w="4" :h="1" :i="0" class="grid-item">
                            <el-button type="primary" icon="el-icon-upload" size="small" class="mr10" @click="showModel = !showModel">显示数据范围</el-button>
                        </grid-item>
                    </grid-layout>
                </template>
                <template v-slot:first_header>
                    <el-select v-model="first_select_value" placeholder="请选择" size="small">
                        <el-option v-for="item in options" :key="item.name" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </template>
                <template v-slot:second_header>
                    <el-select v-model="second_select_value" placeholder="请选择" size="small">
                        <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </template>
            </vxe-grid>
            <el-dialog title="显示数据范围" :visible.sync="showModel" width="750px">
                <el-form label-width="80px">
                    <el-form-item label="活动名称">
                        <el-select v-model="modelSelectValue" placeholder="请选择活动区域">
                            <el-option label="默认合价" value="1"></el-option>
                            <el-option label="默认单价" value="2"></el-option>
                            <el-option label="默认工程量" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="价格类型">
                        <el-radio-group v-model="requestData.rangeType">
                            <el-radio label="addup">合价</el-radio>
                            <el-radio label="rateCost">单价</el-radio>
                            <el-radio label="quantity">工程量</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="增加大于">
                        <el-input v-model="requestData.rangeAmount" placeholder="请输入内容" onInput="value = value.replace(/[^\d]/g,'')">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="增幅大于">
                        <el-input v-model="requestData.rangeRate" placeholder="请输入内容" onInput="value = value.replace(/[^\d]/g,'')">
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="同时满足">
                        <el-switch
                                v-model="requestData.both"
                                active-text="是"
                                inactive-text="否"
                                :active-value="'2'"
                                :inactive-value="'1'">
                        </el-switch>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="showModel = false">取 消</el-button>
                    <el-button type="primary" @click="btnEntry">确 定</el-button>
                </div>
            </el-dialog>
        </grid-item>
    </grid-layout>
</template>

<script>
    import VueGridLayout from 'vue-grid-layout';
    import { selectAnalysis,selectConditionArray,getProjectTreeJsonById } from '@/api/modules/analysisDetail';
    export default {
        name: 'Analysis-detail',
        data() {
            return {
                defaultExpandKeys : [],
                clickRowId : '',
                clickRowLevelType : '',
                rowNodeShowName : '',
                showHeader: true,
                testLayout: [
                    {"x":0,"y":0,"w":10,"h":1,"i":"0", static: true},
                    {"x":10,"y":0,"w":50,"h":1,"i":"1", static: true},
                ],
                //总容器样式
                styleObject: {
                    backgroundColor: 'rgba(224,224,224,0.51)',
                    minHeight:'1030px',
                },
                //
                //容器内部 左侧 样式
                styleObject_1: {
                    backgroundColor: 'rgb(255, 255, 255)',
                    width: '20%',
                    marginRight: '5px'
                },
                //容器内部 右侧 样式
                styleObject_2: {
                    backgroundColor: 'rgb(255, 255, 255)',
                    width: '80%',
                    marginLeft: '5px'
                },
                pannelClass: 'el-icon-d-arrow-left',
                tableCustom: {
                    storage: true
                },
                //zuocemianban
                leftPanel: 5,

                rightPanel: 19,
                //panel height
                gridHeight: window.innerHeight - 60,
                //
                layoutHeight: window.innerHeight - 125,
                //右侧表格 工具栏
                tableToolbar: {
                    refresh: true,
                    custom: true,
                    slots: {
                        buttons: 'toolbar_buttons'
                    },
                    export: true,
                    print: true,
                    zoom: true,
                },
                //动态字段控制
                fields:['controlPrice','bidPrice','reportPrice','beforePrice','afterPrice'],
                //右侧表格列 属性
                tableColumn: [
                    {type: 'seq', width: 60, title: '序号',params:0},
                    {field: 'qdbm', width: 60, title: '清单编码',params:0},
                    {
                        params:1,
                        title: '分类',
                        children: [
                            {field: 'first_projectFeatures', width: 280, title: '清单特征',showOverflow:'tooltip',params:1},
                            {field: 'first_unit', width: 100, title: '计量单位',params:1},
                            {field: 'first_quantity', width: 100, title: '工程量', sortable: true,params:1},
                            {field: 'first_rateCost', width: 100, title: '单价', sortable: true,params:1},
                            {field: 'first_addup', width: 100, title: '合计', sortable: true,params:1},
                        ],
                        slots: {header: 'first_header'}
                    },
                    {
                        params:2,
                        title: '分类',
                        children: [
                            {field: 'second_projectFeatures', width: 280, title: '清单特征',showOverflow:'tooltip',params:2},
                            {field: 'second_unit', width: 100, title: '计量单位',params:2},
                            {field: 'second_quantity', width: 100, title: '工程量', sortable: true,params:2},
                            {field: 'second_rateCost', width: 100, title: '单价', sortable: true,params:2},
                            {field: 'second_addup', width: 100, title: '合计', sortable: true,params:2},
                        ],
                        slots: {header: 'second_header'}
                    },
                    {
                        params: 0,
                        title: '增减量',
                        children: [
                            {field: 'third_quantity', width: 100, title: '工程量', sortable: true},
                            {field: 'third_rateCost', width: 100, title: '单价', sortable: true},
                            {field: 'third_addup', width: 100, title: '合计', sortable: true},
                        ],
                    },
                    {
                        params:0,
                        title: '增减幅度',
                        children: [
                            {field: 'forth_quantity', width: 100, title: '工程量', sortable: true},
                            {field: 'forth_rateCost', width: 100, title: '单价', sortable: true},
                            {field: 'forth_addup', width: 100, title: '合计', sortable: true},
                        ],
                    },
                ],
                //表头下拉框 数据
                options: [],
                //第一个下拉框选项值
                first_select_value: '1007002',
                //第二个下拉框选项值
                second_select_value:'1007002',
                oneTableColumn:[
                    {field: 'xmmc', width: '30%', title: '项目名称', treeNode: true,showOverflow:'tooltip'},
                    {field: 'dxgcmc', width: '30%', title: '单项工程名称',showOverflow:'tooltip'},
                    {field: 'dwgcmc', width: '40%', title: '单位工程名称',showOverflow:'tooltip'},
                ],
                //左侧表格 工具栏
                oneTableToolbar:{
                    slots: {
                        buttons: 'toolbar_one_buttons'
                    },
                },
                //测试模拟数据
                testData:[{"id":"20000","parentId":"","name":"图片 20000.png","size":"66k11","type":"png","date":"2019-05-16","createTime":"1212-01-01","updateTime":1591166527766},{"id":"41000","parentId":"40000","name":"xxx 41000.mp4","size":"135k","type":"mp4","date":"2019-06-02","createTime":"","updateTime":"","children":[]},{"id":"40000","parentId":"","name":"文件夹 40000","size":"26k","type":"mp4","date":"2019-03-16","createTime":"","updateTime":"","hasChild":true},{"id":"33000","name":"在线文档 33000.txt","size":"95k","type":"txt","date":"2019-06-16","parentId":"30000","createTime":"","updateTime":"","children":[]},{"id":"32322","name":"在线观看 32322.avi","size":"5k","type":"avi","date":"2019-09-09","parentId":"32320","createTime":"","updateTime":"","children":[]},{"id":"32321","name":"音乐 32321.mp3","size":"5k","type":"mp3","date":"2019-06-06","parentId":"32320","createTime":"","updateTime":"","children":[]},{"id":"32320","name":"文件夹 32320","size":"88k","type":"","date":"2019-08-31","parentId":"32300","createTime":"","updateTime":"","children":[{"id":"32321","name":"音乐 32321.mp3","size":"5k","type":"mp3","date":"2019-06-06","parentId":"32320","createTime":"","updateTime":"","children":[]},{"id":"32322","name":"在线观看 32322.avi","size":"5k","type":"avi","date":"2019-09-09","parentId":"32320","createTime":"","updateTime":"","children":[]}]},{"id":"32310","name":"某视频 32310.mp4","size":"75k","type":"mp4","date":"2019-06-16","parentId":"32300","createTime":"","updateTime":"","children":[]},{"id":"32300","name":"文件夹 32300","size":"678k","type":"","date":"2019-01-10","parentId":"32000","createTime":"","updateTime":"","children":[{"id":"32310","name":"某视频 32310.mp4","size":"75k","type":"mp4","date":"2019-06-16","parentId":"32300","createTime":"","updateTime":"","children":[]},{"id":"32320","name":"文件夹 32320","size":"88k","type":"","date":"2019-08-31","parentId":"32300","createTime":"","updateTime":"","children":[{"id":"32321","name":"音乐 32321.mp3","size":"5k","type":"mp3","date":"2019-06-06","parentId":"32320","createTime":"","updateTime":"","children":[]},{"id":"32322","name":"在线观看 32322.avi","size":"5k","type":"avi","date":"2019-09-09","parentId":"32320","createTime":"","updateTime":"","children":[]}]}]},{"id":"32221","name":"vxe-table 从入门到放弃 32221.pdf","size":"85k","type":"pdf","date":"2019-06-30","parentId":"32220","createTime":"","updateTime":"","children":[]},{"id":"32220","name":"文件夹 32220","size":"33k","type":"","date":"2019-08-31","parentId":"32200","createTime":"","updateTime":"","children":[{"id":"32221","name":"vxe-table 从入门到放弃 32221.pdf","size":"85k","type":"pdf","date":"2019-06-30","parentId":"32220","createTime":"","updateTime":"","children":[]}]},{"id":"32210","name":"vxe-table 从入门到住院 32210.pdf","size":"75k","type":"pdf","date":"2019-06-16","parentId":"32200","createTime":"","updateTime":"","children":[]},{"id":"32200","name":"文件夹 32000","size":"33k","type":"","date":"2019-08-16","parentId":"32000","createTime":"","updateTime":"","children":[{"id":"32210","name":"vxe-table 从入门到住院 32210.pdf","size":"75k","type":"pdf","date":"2019-06-16","parentId":"32200","createTime":"","updateTime":"","children":[]},{"id":"32220","name":"文件夹 32220","size":"33k","type":"","date":"2019-08-31","parentId":"32200","createTime":"","updateTime":"","children":[{"id":"32221","name":"vxe-table 从入门到放弃 32221.pdf","size":"85k","type":"pdf","date":"2019-06-30","parentId":"32220","createTime":"","updateTime":"","children":[]}]}]},{"id":"32100","name":"入门教程 32100.mp4","size":"35k","type":"mp4","date":"2019-05-16","parentId":"32000","createTime":"","updateTime":"","children":[]},{"id":"32000","name":"文件夹 32000","size":"33k","type":"","date":"2019-05-16","parentId":"30000","createTime":"","updateTime":"","children":[{"id":"32100","name":"入门教程 32100.mp4","size":"35k","type":"mp4","date":"2019-05-16","parentId":"32000","createTime":"","updateTime":"","children":[]},{"id":"32200","name":"文件夹 32000","size":"33k","type":"","date":"2019-08-16","parentId":"32000","createTime":"","updateTime":"","children":[{"id":"32210","name":"vxe-table 从入门到住院 32210.pdf","size":"75k","type":"pdf","date":"2019-06-16","parentId":"32200","createTime":"","updateTime":"","children":[]},{"id":"32220","name":"文件夹 32220","size":"33k","type":"","date":"2019-08-31","parentId":"32200","createTime":"","updateTime":"","children":[{"id":"32221","name":"vxe-table 从入门到放弃 32221.pdf","size":"85k","type":"pdf","date":"2019-06-30","parentId":"32220","createTime":"","updateTime":"","children":[]}]}]},{"id":"32300","name":"文件夹 32300","size":"678k","type":"","date":"2019-01-10","parentId":"32000","createTime":"","updateTime":"","children":[{"id":"32310","name":"某视频 32310.mp4","size":"75k","type":"mp4","date":"2019-06-16","parentId":"32300","createTime":"","updateTime":"","children":[]},{"id":"32320","name":"文件夹 32320","size":"88k","type":"","date":"2019-08-31","parentId":"32300","createTime":"","updateTime":"","children":[{"id":"32321","name":"音乐 32321.mp3","size":"5k","type":"mp3","date":"2019-06-06","parentId":"32320","createTime":"","updateTime":"","children":[]},{"id":"32322","name":"在线观看 32322.avi","size":"5k","type":"avi","date":"2019-09-09","parentId":"32320","createTime":"","updateTime":"","children":[]}]}]}]},{"id":"31200","name":"文件 31200","size":"224k","type":"java","date":"2019-05-16","parentId":"31000","createTime":"","updateTime":"","children":[]},{"id":"31100","name":"从入门到放弃 31100.js","size":"40k","type":"js","date":"2019-05-16","parentId":"31000","createTime":"","updateTime":"","children":[]},{"id":"31000","name":"文件夹 31000","size":"9k","type":"","date":"2019-05-16","parentId":"30000","createTime":"","updateTime":"","children":[{"id":"31100","name":"从入门到放弃 31100.js","size":"40k","type":"js","date":"2019-05-16","parentId":"31000","createTime":"","updateTime":"","children":[]},{"id":"31200","name":"文件 31200","size":"224k","type":"java","date":"2019-05-16","parentId":"31000","createTime":"","updateTime":"","children":[]}]},{"id":"30000","parentId":"","name":"文件夹 30000","size":"3k","type":"","date":"2019-05-16","createTime":"","updateTime":"","hasChild":true},{"id":"123200","name":"文件 123200","size":"105k","type":"avi","date":"2019-05-20","parentId":"123000","createTime":"","updateTime":"","children":[]},{"id":"123100","name":"xxx 123100.avi","size":"105k","type":"avi","date":"2019-05-16","parentId":"123000","createTime":"","updateTime":"","children":[]},{"id":"123000","parentId":"12000","name":"文件 123000","size":"81k","type":"mp4","date":"2019-05-17","createTime":"","updateTime":"","children":[{"id":"123100","name":"xxx 123100.avi","size":"105k","type":"avi","date":"2019-05-16","parentId":"123000","createTime":"","updateTime":"","children":[]},{"id":"123200","name":"文件 123200","size":"105k","type":"avi","date":"2019-05-20","parentId":"123000","createTime":"","updateTime":"","children":[]}]},{"id":"122000","parentId":"12000","name":"xxx 122000.avi","size":"80k","type":"avi","date":"2019-05-16","createTime":"","updateTime":"","children":[]},{"id":"12110","parentId":"12100","name":"某个页面 12110.html","size":"100k","type":"html","date":"2019-05-16","createTime":"","updateTime":"","children":[]},{"id":"12100","parentId":"12000","name":"图片 12100.png","size":"60k","type":"","date":"2019-05-16","createTime":"","updateTime":"","children":[{"id":"12110","parentId":"12100","name":"某个页面 12110.html","size":"100k","type":"html","date":"2019-05-16","createTime":"","updateTime":"","children":[]}]},{"id":"12000","parentId":"10000","name":"文件夹 12000","size":"22k","type":"","date":"2019-05-16","createTime":"","updateTime":"","children":[{"id":"12100","parentId":"12000","name":"图片 12100.png","size":"60k","type":"","date":"2019-05-16","createTime":"","updateTime":"","children":[{"id":"12110","parentId":"12100","name":"某个页面 12110.html","size":"100k","type":"html","date":"2019-05-16","createTime":"","updateTime":"","children":[]}]},{"id":"122000","parentId":"12000","name":"xxx 122000.avi","size":"80k","type":"avi","date":"2019-05-16","createTime":"","updateTime":"","children":[]},{"id":"123000","parentId":"12000","name":"文件 123000","size":"81k","type":"mp4","date":"2019-05-17","createTime":"","updateTime":"","children":[{"id":"123100","name":"xxx 123100.avi","size":"105k","type":"avi","date":"2019-05-16","parentId":"123000","createTime":"","updateTime":"","children":[]},{"id":"123200","name":"文件 123200","size":"105k","type":"avi","date":"2019-05-20","parentId":"123000","createTime":"","updateTime":"","children":[]}]}]},{"id":"11000","parentId":"10000","name":"某 11000.avi","size":"11k","type":"avi","date":"2019-05-16","createTime":"","updateTime":"","children":[]},{"id":"10000","parentId":"","name":"文件夹 10000","size":"53k","type":"","date":"2019-05-16","createTime":"","updateTime":"","hasChild":true}],
                //模拟数据 转化
                leftTreeGrid: [],
                //表格自定义对象数组
                grid_data:[],
                //对下拉框 真实 value值进行储存
                selectRedioMap: new Map(),
                //直接获取 表合计总额
                footerSumValue: 0,
                //请求得数据对象
                requestData:{
                    projectId:'',
                    busProContractTreeId:'',
                    phases:'',
                    rangeType:"addup",
                    rangeAmount:"200",
                    rangeRate:"3",
                    both:"1",
                    tag:'0'
                },
                //控制弹出面板
                showModel:false,
                //对话框 下拉框绑定得筛选值
                modelSelectValue:'1',
            }
        },
        methods: {
            selectConditionArrayInfo(){
                selectConditionArray({
                    "id":this.curProjectId, //this.requestData.projectId,
                    "tag":"0"
                }).then(res=>{
                    this.options = res.data;
                    this.options = [{"name":"控制价","value":"1007002"},{"name":"中标价","value":"1007003"},{"name":"报审价","value":"1007004"},{"name":"初审价","value":"1007005"},{"name":"审定价","value":"1007006"},{"name":"第1期申报进度款","value":"10"},{"name":"第2期申报进度款","value":"20"},{"name":"第1期批准进度款","value":"11"}];
                });
            },
            getProjectTreeInfo(){
                this.defaultExpandKeys = []
                getProjectTreeJsonById({
                    "id":this.curProjectId, //this.requestData.projectId,
                }).then(res=>{
                    if(res.data == null) return

                    this.leftTreeGrid.push(res.data)
                    this.$utils.eachTree(this.leftTreeGrid,item=>{
                        if(item.levelType == 0){
                            item.xmmc = item.sname;
                            item.dxgcmc = '';
                            item.dwgcmc = '';
                        }
                        if(item.levelType == 1){
                            item.xmmc = '';
                            item.dxgcmc = item.sname;
                            item.dwgcmc = '';
                        }
                        if(item.levelType == 2){
                            item.xmmc = '';
                            item.dxgcmc = '';
                            item.dwgcmc = item.sname;
                        }
                    },{ key: 'id', parentKey: 'pid', children: 'children' });

                    //let treeData = []
                    //treeData.push(res.data)
                    let listData = this.$utils.toTreeArray(this.leftTreeGrid)
                    listData.map(x => {this.defaultExpandKeys.push(x.id)})
                    // 重载表格
                    this.$refs.xTable.reloadData(this.leftTreeGrid)
                });
            },
            //控制面板左右伸缩
            controlPannel() {
                if (this.pannelClass == 'el-icon-d-arrow-right') {
                    this.pannelClass = "el-icon-d-arrow-left";
                    //伸
                    this.testLayout = [
                        {"x":0,"y":0,"w":10,"h":1,"i":"0", static: true},
                        {"x":10,"y":0,"w":50,"h":1,"i":"1", static: true},
                    ];
                    this.showHeader = true;
                } else {
                    this.pannelClass = "el-icon-d-arrow-right";
                    //缩
                    this.testLayout = [
                        {"x":0,"y":0,"w":1,"h":1,"i":"0", static: true},
                        {"x":1,"y":0,"w":59,"h":1,"i":"1", static: true},
                    ];
                    this.showHeader = false;
                }
            },
            //表头样式
            headerCellStyle({column, columnIndex}) {
                return {
                    backgroundColor: '#c9f3ee'
                }
            },
            //单元格样式
            cellStyle({row,rowIndex,column, columnIndex}){
                //字体样式为 半透明
                let header_property = [undefined,'qdbm','second_projectFeatures','second_unit','second_quantity','second_rateCost','second_addup'];
                //字体样式为 红色或者 绿色
                let header_property_third = ['third_quantity','third_rateCost','third_addup'];
                //初始化颜色
                let style =  {fontSize: '18px', color: 'rgba(7,0,69,0.77)'};
                //判断两个表头得 下拉框是否相等
                if(this.first_select_value != this.second_select_value && this.$utils.includes(header_property,column.property)){
                    style.color = 'rgba(7,0,69,0.39)';
                }
                //判断第三大列 得 工程量大小
                if(this.$utils.includes(header_property_third,column.property)){
                    if(row.third_quantity > 0){
                        style.color = 'rgba(255,84,94,0.99)';
                    }
                    if(row.third_quantity == 0){
                        style.color = 'rgba(7,0,69,0.77)';
                    }
                    if(row.third_quantity < 0){
                        style.color = 'rgba(121,255,131,0.77)';
                    }
                }
                return style;
            },
            //表体样式
            tableStyle({column, columnIndex}) {
                //let color = ['rgba(204,241,253,0.79)','rgba(74,245,73,0.5)','rgba(245,214,52,0.5)'];
                let color = ['#d8edf9','#9eefd1','#f5f5ad']
                return {
                    backgroundColor: column.params ? color[column.params] : color[0],
                    borderTop : '1px solid #ccc',
                    borderLeft : '1px solid #ccc',
                    padding : '3px 0px',
                }
            },
            rowStyle({row, rowIndex}) {
                if (this.clickRowId == row.id) return { backgroundColor: '#e2d192' }
                else return {backgroundColor : ['rgba(45,183,245,0.31)','rgba(45,183,245,0.26)','rgba(45,183,245,0.15)'][row.levelType]}
            },
            //表尾部样式
            footerMethod ({ columns, data }) {
                return [
                    columns.map((column, columnIndex) => {
                        // if (this.$utils.includes(['first_addup', 'second_addup', 'third_addup'],column.property)) {
                        //     return this.footerSumValue
                        // }
                        if(column.property == 'first_addup'){
                            return this.footerSumValue.sumstr1;
                        }
                        if(column.property == 'second_addup'){
                            return this.footerSumValue.sumstr2;
                        }
                        if(column.property == 'third_addup'){
                            return this.footerSumValue.sumPrice;
                        }
                        if (columnIndex === 0) {
                            return '合计'
                        }
                        if (this.$utils.includes([4,5,6,9,10,11,12,13,14,15,16,17],columnIndex)) {
                            return '0'
                        }
                        return 'N/A'
                    })
                ]
            },
            getGridData(data){
                //对请求得数据进行 重新拼凑
                let grid_data_list = [];
                // this.tableData.data.forEach(item=>{
                //     let grid_data_item = {
                //         qdbm:item.code,//清单编码
                //         first_projectFeatures: item[this.fields[this.first_select_value]].projectFeatures || '',//第一个表 清单特征
                //         first_unit:item[this.fields[this.first_select_value]].unit|| '',//第一个表 计量单位
                //         first_quantity: this.$utils.toFixedString(item[this.fields[this.first_select_value]].quantity,3),//第一个表  工程量
                //         first_rateCost:this.$utils.toFixedString(item[this.fields[this.first_select_value]].rateCost,2),//第一个表 单价
                //         first_addup:this.$utils.toFixedString(item[this.fields[this.first_select_value]].addup,2),//第一个表 合价
                //         second_projectFeatures:item[this.fields[this.second_select_value]].projectFeatures|| '',//第二个表 清单特征
                //         second_unit:item[this.fields[this.second_select_value]].unit|| '',//第二个表 计量单位
                //         second_quantity:this.$utils.toFixedString(item[this.fields[this.second_select_value]].quantity,3),//第二个表  工程量
                //         second_rateCost:this.$utils.toFixedString(item[this.fields[this.second_select_value]].rateCost,2),//第二个表 单价
                //         second_addup:this.$utils.toFixedString(item[this.fields[this.second_select_value]].addup,2),//第二个表 合价
                //     };
                //
                //     grid_data_item.first_quantity = grid_data_item.first_quantity == '0.000' ? '':grid_data_item.first_quantity;
                //     grid_data_item.first_rateCost = grid_data_item.first_rateCost == '0.00' ? '':grid_data_item.first_rateCost;
                //     grid_data_item.first_addup = grid_data_item.first_addup == '0.00' ? '':grid_data_item.first_addup;
                //
                //     grid_data_item.second_quantity = grid_data_item.second_quantity == '0.000' ? '':grid_data_item.second_quantity;
                //     grid_data_item.second_rateCost = grid_data_item.second_rateCost == '0.00' ? '':grid_data_item.second_rateCost;
                //     grid_data_item.second_addup = grid_data_item.second_addup == '0.00' ? '': grid_data_item.second_addup;
                //
                //     grid_data_item.third_quantity = this.$utils.toFixedString(this.$utils.subtract(grid_data_item.second_quantity,grid_data_item.first_quantity),3);//第三个表 工程量
                //     grid_data_item.third_rateCost = this.$utils.toFixedString(grid_data_item.first_rateCost || grid_data_item.second_rateCost || 0,2);//第三个表 单价
                //     grid_data_item.third_addup = this.$utils.toFixedString(this.$utils.multiply(grid_data_item.third_quantity,grid_data_item.third_rateCost),2);//第三个表 合价
                //
                //     if(grid_data_item.third_quantity == '0.000'){
                //         grid_data_item.third_rateCost = '0.00'
                //     }
                //
                //     grid_data_item.forth_quantity = this.$utils.toFixedString(this.$utils.subtract(grid_data_item.second_quantity,grid_data_item.first_quantity),2);//第三个表 工程量
                //     grid_data_item.forth_rateCost = this.$utils.toFixedString(grid_data_item.first_rateCost || grid_data_item.second_rateCost || 0,2) ;//第三个表 单价
                //     grid_data_item.forth_addup = this.$utils.toFixedString(this.$utils.multiply(grid_data_item.forth_quantity,grid_data_item.forth_rateCost),2);//第三个表 合价
                //
                //     if(grid_data_item.forth_quantity = '0.000'){
                //         grid_data_item.forth_rateCost = '0.00'
                //     }
                //
                //     grid_data_item.forth_quantity = grid_data_item.forth_quantity < 0 || grid_data_item.first_quantity == '' || grid_data_item.second_quantity == ''?'---' : grid_data_item.forth_quantity + '%';
                //     grid_data_item.forth_rateCost = grid_data_item.forth_rateCost < 0 || grid_data_item.first_quantity == '' || grid_data_item.second_quantity == ''?'---' : grid_data_item.forth_rateCost + '%';
                //     grid_data_item.forth_addup = grid_data_item.forth_addup < 0 || grid_data_item.first_quantity == '' || grid_data_item.second_quantity == ''?'---' : grid_data_item.forth_addup + '%';


                //     grid_data_list.push(grid_data_item);
                // });
                data.forEach(item=>{
                    let grid_data_item = {
                        qdbm:item.code,//清单编码
                        first_projectFeatures: item.str1.projectFeatures || '',//第一个表 清单特征
                        first_unit: item.str1.unit || '',//第一个表 计量单位
                        first_quantity: this.$utils.toFixedString(item.str1.quantity,3),//第一个表  工程量
                        first_rateCost:this.$utils.toFixedString(item.str1.rateCost,2),//第一个表 单价
                        first_addup:this.$utils.toFixedString(item.str1.addup,2),//第一个表 合价
                        second_projectFeatures: item.str2.projectFeatures || '',//第二个表 清单特征
                        second_unit:item.str2.unit || '',//第二个表 计量单位
                        second_quantity:this.$utils.toFixedString(item.str2.quantity,3),//第二个表  工程量
                        second_rateCost:this.$utils.toFixedString(item.str2.rateCost,2),//第二个表 单价
                        second_addup:this.$utils.toFixedString(item.str2.addup,2),//第二个表 合价
                        third_quantity:item.decrement.decrementQuality,
                        third_rateCost:item.decrement.decrementRateCost,
                        third_addup:item.decrement.decrementAddup,
                        forth_quantity:item.range.rangePrice,
                        forth_rateCost:item.range.rangeQuality,
                        forth_addup:item.range.rangeSumPrice,
                    };
                    grid_data_list.push(grid_data_item);
                });
                return grid_data_list;
            },
            //左侧树表格行 点击事件
            leftGridItemClick(row, rowIndex){
                this.clickRowId = row.row.id
                this.clickRowLevelType = row.row.levelType
                // 设置右边结构名字
                let _pname = this.leftTreeGrid[0].sname
                let name = row.row.sname
                if (row.row.levelType === 0) {
                    this.rowNodeShowName = name
                } else if (row.row.levelType === 1) {
                    this.rowNodeShowName = _pname + ' | ' + name
                } else {
                    // 当前结构树ID
                    let _dname = this.leftTreeGrid[0].children.find(x => x.id === row.row.pid).sname
                    this.rowNodeShowName = _pname + ' | ' + _dname + ' | ' + name
                }

                if(row.row.levelType == 2){
                    //this.requestData.projectId = row.row.aid;
                    this.requestData.busProContractTreeId = row.row.id;
                    this.selectAnalysis();
                }
            },
            //对请求接口得二次封装
            selectAnalysis(){
                //这里得代码涉及作用域得问题 必须拿出来..不能直接写到匿名函数内部...否则会一直underfind
                this.requestData.projectId = this.curProjectId
                this.requestData.phases = this.first_select_value + ',' + this.second_select_value;
                selectAnalysis(this.requestData).then(res=>{
                    this.grid_data = this.getGridData(res.data.list);
                    this.footerSumValue = res.data
                });
            },
            //筛选框 确定按钮事件
            btnEntry () {
                this.showModel = false;
                this.selectAnalysis();
            }
        },
        created() {
            //this.requestData.projectId = this.$route.query.projectId;
            this.selectConditionArrayInfo()
            this.getProjectTreeInfo()
        },
        computed: {
            // 当前的 项目Id
            curProjectId() {
                return this.$route.query.projectId
            },
        },
        watch:{
            // 监听项目ID 的变化
            curProjectId(val) {
                this.leftTreeGrid = []
                this.selectConditionArrayInfo()
                this.getProjectTreeInfo()
            },
            first_select_value(val){
                if(this.clickRowLevelType==2) this.selectAnalysis();
            },
            second_select_value(val){
                if(this.clickRowLevelType==2) this.selectAnalysis();
            },
            modelSelectValue(val){
                switch (val) {
                    case '1':{
                        this.requestData.rangeType = 'addup';
                        this.requestData.rangeAmount = '200';
                        this.requestData.rangeRate = '3';
                        this.requestData.both = '2';
                        break;
                    }
                    case '2':{
                        this.requestData.rangeType = 'rateCost';
                        this.requestData.rangeAmount = '300';
                        this.requestData.rangeRate = '6';
                        this.requestData.both = '2';
                        break;
                    }
                    case '3':{
                        this.requestData.rangeType = 'quantity';
                        this.requestData.rangeAmount = '100';
                        this.requestData.rangeRate = '1';
                        this.requestData.both = '2';
                        break;
                    }
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .cellStyle{
        background-color: #eda3f5;
        font-size: 28px;
        color: #606266;
        border-color: #0c1c21;
    }
    .grid-item{
        padding-top: 10px
    }

</style>
